(() => {
  class AVDMegaHeader {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('[data-avd-nav-item]')];
      this.mobile = root.querySelector('[data-avd-mobile]');
      this.openBtn = root.querySelector('[data-avd-mobile-open]');
      this.closeBtns = [...root.querySelectorAll('[data-avd-mobile-close]')];
      this.activeItem = null;
      this.closeTimer = null;
      this.bindDesktop();
      this.bindMobile();
      this.bindGlobal();
    }

    bindDesktop() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-avd-trigger]');
        if (!trigger) return;
        const open = () => this.openItem(item);
        const delayedClose = () => this.queueClose(item);
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', delayedClose);
        trigger.addEventListener('focus', open);
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (window.matchMedia('(min-width: 990px)').matches) {
            item.classList.contains('is-open') ? this.closeItem(item) : this.openItem(item);
          } else {
            this.openMobile(trigger.dataset.avdMobileTarget);
          }
        });
      });
    }

    bindMobile() {
      if (!this.mobile || !this.openBtn) return;
      this.openBtn.addEventListener('click', () => this.openMobile());
      this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.closeMobile()));
    }

    bindGlobal() {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeAll();
          this.closeMobile();
        }
      });
      document.addEventListener('click', (event) => {
        if (!this.root.contains(event.target)) this.closeAll();
      });
    }

    openItem(item) {
      clearTimeout(this.closeTimer);
      this.items.forEach((other) => {
        if (other !== item) this.closeItem(other);
      });
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-avd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this.activeItem = item;
    }

    closeItem(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-avd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (this.activeItem === item) this.activeItem = null;
    }

    queueClose(item) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeItem(item), 140);
    }

    closeAll() {
      this.items.forEach((item) => this.closeItem(item));
    }

    openMobile(activeTitle = null) {
      this.mobile.classList.add('is-open');
      this.mobile.setAttribute('aria-hidden', 'false');
      this.openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';

      if (activeTitle) {
        this.mobile.querySelectorAll('[data-avd-mobile-details]').forEach((details) => {
          details.open = details.dataset.avdMobileTitle === activeTitle;
        });
      }
    }

    closeMobile() {
      if (!this.mobile) return;
      this.mobile.classList.remove('is-open');
      this.mobile.setAttribute('aria-hidden', 'true');
      this.openBtn && this.openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
  }

  const init = () => {
    document.querySelectorAll('[data-avd-header]').forEach((root) => {
      if (root.dataset.avdReady) return;
      root.dataset.avdReady = 'true';
      new AVDMegaHeader(root);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
